// ============================================================================
// 🛡️ V8 / Chromium / Android WebView DOMException.prototype.message Patch
// In modern V8 engines and WebViews, DOMException defines .message as getter-only.
// When libraries (such as eosjs, @wharfkit/protocol-scatter, crypto, or fetch handlers)
// execute `error.message = ...` on a caught DOMException, strict mode throws:
// "TypeError: Cannot set property message of which has only a getter".
// This patch equips DOMException with a functional setter so error chains work safely.
// ============================================================================
if (typeof DOMException !== 'undefined') {
  try {
    const desc = Object.getOwnPropertyDescriptor(DOMException.prototype, 'message');
    if (desc && !desc.set) {
      Object.defineProperty(DOMException.prototype, 'message', {
        get() {
          return this._custom_message !== undefined
            ? this._custom_message
            : (desc.get ? desc.get.call(this) : '');
        },
        set(val) {
          this._custom_message = val;
        },
        configurable: true,
        enumerable: true
      });
    }
  } catch (e) {
    console.warn('DOMException message descriptor patch skipped:', e);
  }
}
